import React from 'react'
import PropTypes from 'prop-types'

const FeedbackConversationTitle = ({ title, itemUrl, itemTitle }) => (
  <div>
    PRODUCT FEEDBACK: {title} for<a href={itemUrl} className="u-ml10">{itemTitle}</a>
  </div>
)

FeedbackConversationTitle.propTypes = {
  title: PropTypes.string.isRequired,
  itemUrl: PropTypes.string.isRequired,
  itemTitle: PropTypes.string.isRequired,
}

export default FeedbackConversationTitle
